import { BatchStatus, Severity } from "node-library/dist/constants";
import { formatCustomDate } from "node-library/dist/helpers/date_helper";
import {
	FrontendCompanyWithAdditionalInfomation,
	FrontendSampleTestBatchComments,
	FrontendUserInfo,
} from "node-library/dist/portal";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { Card, Divider } from "@mui/material";
import { NeutralColor, PrimaryColor } from "node-library/dist/colors";

import { FrontendBatchPageTestBatchDetails } from "node-library/dist/structures/frontendSampleTestBatchPageDefinitions";
import { useSnackbar } from "../../../../../common-components/toast/showToastMessage";
import { sendPOSTRequest } from "../../../../../requestHelper/sendRequest";
import { UserIcon } from "../../../../../common-components/svgIcons";
import { GreenButton } from "../../../../../common-components/button";
import AddIcon from "@mui/icons-material/Add";
import AddCommentModal from "./addCommentModal";
import { getCommentDisplayHTML } from "node-library/dist/helpers/mention_helper";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;

	user: FrontendUserInfo;
	batchDetails: FrontendBatchPageTestBatchDetails;
	setBatchDetails: React.Dispatch<
		React.SetStateAction<FrontendBatchPageTestBatchDetails | undefined>
	>;
}

export default function WorkflowCommentCard(props: Props) {
	const { t: translation } = useTranslation();
	const { openSnackbar } = useSnackbar();

	const { batchDetails, setBatchDetails, user, company } = props;

	//order updatable fields
	const [batchStatus, setBatchStatus] = useState<BatchStatus>(
		batchDetails.batchStatus,
	);

	const [addCommentModalOpen, setAddCommentModalOpen] =
		useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(false);

	const workflowComments: Array<FrontendSampleTestBatchComments> =
		useMemo(() => {
			return batchDetails.workflowComments;
		}, [batchDetails]);

	const batchCommentCard: React.ReactNode = (
		<Card className="card-border-radius-14p card-medium-padding">
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<div>{translation("Comments")}</div>
				<GreenButton
					id={"batch-workflow-add-comment-button"}
					onClick={() => {
						setAddCommentModalOpen(true);
					}}
				>
					<AddIcon></AddIcon>
					{translation("NewComment")}
				</GreenButton>
			</div>
			<div>
				{workflowComments.length > 0 ? (
					workflowComments.map((comment) => {
						return (
							<div>
								<div
									style={{ display: "flex", alignItems: "center", gap: "5px" }}
								>
									<div className="order-details-header-icon-container">
										<UserIcon
											strokeColor={PrimaryColor.PRIMARY_500}
											fillColor={PrimaryColor.PRIMARY_500}
										></UserIcon>
									</div>
									<div className="typography-body-01 typography-bold">
										{`${comment.user.firstName} ${comment.user.lastName}`}
									</div>
								</div>
								<div
									className="workflow-comment"
									dangerouslySetInnerHTML={{
										__html: getCommentDisplayHTML(comment.comment),
									}}
								/>
								<div>{formatCustomDate(comment.inserted as Date)}</div>
							</div>
						);
					})
				) : (
					<div style={{ display: "flex", justifyContent: "center" }}>
						{"No Comments"}
					</div>
				)}
			</div>
		</Card>
	);

	return (
		<div style={{ margin: "0 auto" }}>
			<div>{batchCommentCard}</div>
			{
				<AddCommentModal
					batchDetails={batchDetails}
					open={addCommentModalOpen}
					setOpen={setAddCommentModalOpen}
					user={user}
					setBatchDetails={setBatchDetails}
				/>
			}
		</div>
	);
}
